import { getModule } from "vuex-module-decorators";
import AuthModule from "./module/auth.module";
import NotifModule from "./module/notif.module";
import store from "./store";

export const Auth = getModule(AuthModule, store)

export const Notif = getModule(NotifModule, store)